import { useQuery } from "@tanstack/react-query";
import { fetchKashierSettings } from "../../api/PaymentAPIs";

function Pill({ ok, yes = "مضبوط", no = "غير مضبوط" }) {
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs ${ok ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
      {ok ? yes : no}
    </span>
  );
}

export default function PaymentsSettingsPage() {
  const { data, isLoading, error } = useQuery({ queryKey: ["kashierSettings"], queryFn: fetchKashierSettings });
  if (isLoading) return <p>جاري التحميل...</p>;
  if (error) return <p className="text-red-600">{error.message}</p>;
  return (
    <div className="space-y-4">
      {data?.liveWarning && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-2xl p-4 font-bold">
          الوضع الحالي LIVE. المدفوعات حقيقية.
        </div>
      )}
      {!data?.liveWarning && (
        <div className="bg-amber-50 border border-amber-200 text-amber-800 rounded-2xl p-4">
          الوضع الحالي TEST. لن يتم تحصيل أموال حقيقية.
        </div>
      )}
      <div className="bg-white border border-slate-200 rounded-2xl p-4 space-y-3">
        <Row label="Kashier" value={<Pill ok={data?.enabled} yes="مفعّل" no="متوقف" />} />
        <Row label="البيئة" value={data?.environment} />
        <Row label="معرّف التاجر" value={<Pill ok={data?.merchantIdConfigured} />} />
        <Row label="Payment API Key" value={<Pill ok={data?.paymentApiKeyConfigured} />} />
        <Row label="Secret Key" value={<Pill ok={data?.secretKeyConfigured} />} />
        <Row label="الويبهوك" value={<Pill ok={data?.webhookConfigured} />} />
        <Row label="البطاقة" value={<Pill ok={data?.cardEnabled} yes="مفعّلة" no="متوقفة" />} />
        <Row label="المحفظة" value={<Pill ok={data?.walletEnabled} yes="مفعّلة في الإعداد" no="غير مفعّلة" />} />
        <Row label="جاهز للدفع" value={<Pill ok={data?.readyForCheckout} yes="جاهز" no="غير جاهز" />} />
        <p className="text-sm text-slate-500">المفاتيح لا تُعرض هنا. تُضبط من متغيرات البيئة أو إعدادات السيرفر. تفعيل المحفظة على حساب Kashier خطوة منفصلة.</p>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-slate-100 py-2">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}
